export default __webpack_public_path__ + "static/media/RegStep3.803566c7.png";